// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1_AZJ","cls2":"SocialActionsMenu-cls2__Vv SocialActionsMenu-cls1_AZJ"};